// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-a4992094]{background-color:#ffffff;box-sizing:border-box;border-radius:4px;font-size:16px;line-height:40px;width:150px;padding:0 10px;border:2px solid #2e51a2;text-align:center;cursor:pointer;display:inline-block;text-decoration:none;font-weight:700}a[data-v-a4992094]:hover{background-color:rgba(46,81,162,0.2);text-decoration:none}\n", ""]);
// Exports
module.exports = exports;
